<template>
  <div class="closeModal">
    <svg
      fill="none"
      height="19"
      viewBox="0 0 20 19"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke="#212121" stroke-linecap="round" stroke-width="3">
        <path
          d="m1.5-1.5h21.3972"
          transform="matrix(.717264 .696801 -.717264 .696801 .649414 2)"
        />
        <path
          d="m1.5-1.5h21.3972"
          transform="matrix(.717264 -.696801 .717264 .696801 2.24121 19)"
        />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'CloseX',
};
</script>
